import {useState} from 'react'
import PackingListForm from './PackingListForm';
import PackingListView from './PackingListView';

const PackingList = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
  
  return (
    <>
      {fromIsShown ? (
          <PackingListForm addForm={setFromIsShown} update={upData} />
        ) : (
          <PackingListView addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default PackingList